import React, {
  useState,
  useContext,
  createContext,
  useCallback,
  useMemo,
} from 'react';

const PrintHandleContext = createContext({});

export function PrintProvider({ children }) {
  const [printState, setPrintState] = useState({
    id: '',
  });

  const printHandle = useCallback((value) => {
    setPrintState(() => ({ id: value }));
  }, []);

  const resetPrint = useCallback(() => {
    setPrintState({ id: '' });
  }, []);

  const value = useMemo(
    () => ({
      printState,
      printHandle,
      resetPrint,
    }),
    [printState, printHandle, resetPrint],
  );

  return (
    <PrintHandleContext.Provider value={value}>
      {children}
    </PrintHandleContext.Provider>
  );
}

export function usePrint() {
  const context = useContext(PrintHandleContext);
  return context;
}
